import { KeyboardEvent } from "react";
import { KeyboardKeyCallback } from "./types";

export const useKeyboardA11y = (keyboardKeyCallbacks: KeyboardKeyCallback) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    Object.entries(keyboardKeyCallbacks).forEach(([keyboardKey, callback]) => {
      if (keyboardKey === event.key) {
        event.preventDefault();
        event.stopPropagation();

        callback?.();
      }
    });
  };

  return {
    handleKeyDown,
  };
};
